// ✅ IMPORTS de imágenes
import sistemaIncendiosImg from "@/assets/images/SISTEMA-CONTRA-INCENDIOS.webp";
import equipamientoEPPImg from "@/assets/images/EQUIPAMIENTOS-EPP.webp";
import infraestructuraTIImg from "@/assets/images/INFREESTRUCTURA-DE-TI.webp";

export const CATALOG_ITEMS = [
  {
    title: "Sistemas Contra Incendios",
    description:
      "Equipos y sistemas contra incendios certificados para protección industrial y corporativa.",
    image: sistemaIncendiosImg,
    whatsappMessage: "Hola, deseo cotizar Sistemas Contra Incendios",
  },
  {
    title: "Implementos de Protección EPP",
    description:
      "Equipamiento de seguridad industrial homologado con rigurosos estándares internacionales.",
    image: equipamientoEPPImg,
    whatsappMessage: "Hola, deseo cotizar Implementos de Protección EPP",
  },
  {
    title: "Infraestructura IT y Racks",
    description:
      "Servidores, racks y componentes esenciales para centros de datos de alto rendimiento.",
    image: infraestructuraTIImg,
    whatsappMessage: "Hola, deseo cotizar Infraestructura IT y Racks",
  },
];